import * as React from 'react';
import { connect } from 'react-redux';
import { Button, CardImg, Col, FormGroup, FormText, Input, Row } from "reactstrap";
import { Dispatch } from 'redux';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import 'react-notifications-component/dist/theme.css';
import uploadFileToBlob from '../../services/Azure/azureBlob';
import { messageBoardAction } from '../../actions/messageBoardAction';
import { showAlert } from "../common/functions";
import { DABTextBox, DABDropDown, DABHtmlEditor, DABButton, ConfirmModal, DABBackToList, LoadingSpinnerModal } from '../../components/dab';
import { languageAction } from '../../actions/languageAction';
import { channelAction } from '../../actions/channelAction';
import { MultiSelect } from "react-multi-select-component";
import { userAction } from '../../actions/userAction';
import NoImage from '../../assets/images/noimage.png'

interface IMessageBoardDetailsProps {
	dispatch: Dispatch<any>;
	messageBoardData: any;
	id: number;
	callback: any;
	languageData: any;
	userData: any;
	channelData: any;
}

class Guid {
	static newGuid() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0,
				v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}
}

const MessageBoardDetails: React.SFC<IMessageBoardDetailsProps> = ({
	dispatch, messageBoardData, id, callback, languageData, userData, channelData }) => {

	const history = useHistory();

	const messageBoard = {
		messageBoardId: 0,
		title: "",
		sortOrder: 0,
		uniqueCode: "",
		isActive: true,
		descriptionHtml: "",
		iconImageUrl: "",
		bannerImageUrl: "",
		languageCode: "",
		primaryChannelId: -1,
		moderatorsId: [] as any,
		iconLocalPath: [] as any,
		bannerLocalPath: [] as any,
		icon: "",
		banner: "",
		allowAttachments: true,
		dailyMessageLimit: 0,
		dailyReplyLimit: 0,
		isPrivate: false,
		isPrayerHotlineChannel: false,
		isPrayerHotlineChannelEnabled: false,
		isEmailSend: false,
		topicCount:0
	};

	const initialChannelInputValue = {
		getActiveOnly: true,
		sortColumn: "title",
		sortDirection: "asc"
	};

	const [showModal, setShowModal] = useState(false); 
	const [isDetailLoaded, setDetailLoaded] = useState(false); 
	const [messageObject, setMessageObject] = useState(messageBoard);
	const [isPreviewPage, setIsPreviewPage] = useState(false); 
	const [isActive, setIsActive] = useState(true); 
	const [allowAttachments, setAllowAttachments] = useState(true); 
	const [formSubmit, setformSubmit] = useState(false); 
	const [isErrorOnPage, setIsErrorOnPage] = useState(false); 
	const [content, setContent] = useState(""); 
	const [isLangListLoaded, setIsLangListLoaded] = useState(false); 
	const [languageName, setLanguageName] = useState(""); 
	const initialValue = [{ text: "English", value: "en", checked: false }];
	const [langList, setLangList] = useState(initialValue); 
	const [isChannelListLoaded, setIsChannelListLoaded] = useState(false);
	const initialValueChannel = [{ text: "", value: -1, checked: false }];
	const [channelName, setChannelName] = useState("");
	const [channelList, setChannelList] = useState(initialValueChannel); 
	const inputIconFile = React.useRef<HTMLInputElement>(null); 
	const inputBannerFile = React.useRef<HTMLInputElement>(null); 
	const [isUserByRolesLoaded, setIsUserByRolesLoaded] = useState(false);
	const [moderatorsList, setModeratorsList] = useState([]);
	const [selectedModerators, setSelectedModertors] = useState([]);
	const [isEditIconChange, setIsEditIconChange] = useState(false);
	const [isEditBannerChange, setIsEditBannerChange] = useState(false);
	const [channelFilterInput, setChannelFilerInput] = useState(initialChannelInputValue);
	const [isPrivate, setIsPrivate] = useState(false);
	const [isPrayerHotlineChannel, setIsPrayerHotlineChannel] = useState(false);
	const [isEmailSend, setIsEmailSend] = useState(false);
	const [isDescEmpty, setIsDescEmpty] = useState(false); 
	const [isIconEmpty, setIsIconEmpty] = useState(false); 
	const [isBannerEmpty, setIsBannerEmpty] = useState(false); 
	const [selectedIconFileName, setSelectedIconFileName] = useState(""); 
	const [selectedBannerFileName, setSelectedBannerFileName] = useState(""); 
	const [iconFileRequired, setIconFileRequired] = useState(true); 
	const [bannerFileRequired, setBannerFileRequired] = useState(true); 
	const [isDetailDataFetched, setIsDetailDataFetched] = useState(false); 
	const [isSaveInProgress, setIsSaveInProgress] = useState(false);
	const [isDirty, setIsDirty] = useState<boolean>(false)
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showHotlineConfirmModal, setShowHotlineConfirmModal] = useState(false);

	
	React.useEffect(() => {
		dispatch(languageAction.languageGetByfilter());
		dispatch(channelAction.channelGetAll(channelFilterInput));
		dispatch(userAction.userRoleGet("Community"));

		if ((id <= 0)) {
			callback("Create New Message Board");
		}
		if (id > 0) { setShowModal(true); }
	}, []);

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleLanguageChange = (event) => {
		langList && langList.map((data: any) => {
			if (data.value === event.target.value) {
				setLanguageName(data.text);
			}
		});
	};

	const handleChannelChange = (event) => {
		channelList && channelList.map((data: any) => {
			if (data.value == event.target.value) {
				setChannelName(data.text);
			}
		});
	};

	if (messageBoardData) {
		if (messageBoardData.isError && !isErrorOnPage && !messageBoardData.isSuccess) {
			if (showModal) {
				setIsSaveInProgress(false);
				setShowModal(false);
			}
			messageBoardData.isError = false;
			if (messageBoardData.status === 'Unauthorized') {
				history.push("/401");
			} else {
				showAlert(messageBoardData.status, true);
			}
			setIsErrorOnPage(true);
		}

		if (messageBoardData.isSuccess && (messageBoardData.isAddOrEditLoaded || messageBoardData.isDeleted)
			&& !messageBoardData.isError) {
			messageBoardData.isSuccess = false;
			messageBoardData.isAddOrEditLoaded = false;
			if (showModal) {
				setShowModal(false);
			}			
			window.localStorage.setItem('alertMessage', messageBoardData.status);
			window.location.href = "/messageboard";			
		}
		
		if (messageBoardData.isSingleMessageLoaded) {
			if (!isDetailLoaded && messageBoardData.aMessageData) {
				if (messageBoardData.aMessageData && messageBoardData.aMessageData !== null) {
					setMessageObject(messageBoardData.aMessageData);
					if (messageBoardData.aMessageData.iconImageUrl.trim() == "") {
						setIsIconEmpty(true);
					}
					else {
						setIsIconEmpty(false);
					};

					if (messageBoardData.aMessageData.bannerImageUrl.trim() == "") {
						setIsBannerEmpty(true);
					}
					else {
						setIsBannerEmpty(false);
					};
					setIsActive(messageBoardData.aMessageData.isActive);
					setContent(messageBoardData.aMessageData.descriptionHtml);
					setAllowAttachments(messageBoardData.aMessageData.allowAttachments);
					setIsPrivate(messageBoardData.aMessageData.isPrivate);
					setIsPrayerHotlineChannel(!!messageBoardData.aMessageData.isPrayerHotlineChannel);
					setIsEmailSend(!!messageBoardData.aMessageData.isEmailSend);
					callback(messageBoardData.aMessageData.title + " - Details");
					setDetailLoaded(true);
					
				}
			}
			messageBoardData.isSingleMessageLoaded = false;
			messageBoardData.isSuccess = false;		
			if (!isSaveInProgress && showModal) {
				setShowModal(false);
			}
		}		
	}

	if (((id > 0 && isDetailLoaded) || (id <=0)) && userData && userData.isSuccess && !isUserByRolesLoaded) {
		if (userData.isUserByRolesLoaded && !isUserByRolesLoaded) {
			if (userData.usersByRolesData && userData.usersByRolesData.length > 0) {
				let options = userData.usersByRolesData.map(el => (
					{ label: el.name, value: el.userId }
				));
				if (id > 0) {
					let moderators = [] as any;
					messageObject.moderatorsId.forEach(m => {
						userData.usersByRolesData.forEach(el => {
							if (m === el.userId) {
								{
									moderators.push({
										label: el.name, value: el.userId
									})
								}
							}
						})
					})
					setSelectedModertors(moderators);
				}
				setModeratorsList(options);
				setIsUserByRolesLoaded(true);
			}
		}
	}

	if (langList && !isLangListLoaded) {
		if (languageData.items.length > 0) {
			var list: any[] = [];
			languageData.items.forEach((data) => {
				var item = { text: data.name, value: data.languageCode, checked: true };
				list.push(item);
			});
			setLangList(list);
			setLanguageName(langList[0].text);
			
			setMessageObject({
				...messageObject,
				languageCode: langList[0].value
			});
			setIsLangListLoaded(true);
		}
	}

	if (channelList && !isChannelListLoaded) {
		if (channelData.items.length > 0) {
			var list: any[] = [];
			list.push(initialValue);
			channelData.items.forEach((data) => {
				var item = { text: data.title, value: data.channelId, checked: true };
				list.push(item);
			});
			setChannelList(list);
			setChannelName(channelList[0].text);

			setMessageObject({
				...messageObject,
				primaryChannelId: channelList[0].value
			});
			setIsChannelListLoaded(true);
		}
	}

	if (id > 0 && langList && isLangListLoaded && channelList && isChannelListLoaded && !isDetailDataFetched) {
		setIsDetailDataFetched(true);
		dispatch(messageBoardAction.messageBoardGetDetail(id));		
	}


	const handleNextClick = (event) => {
		event.preventDefault();
		if (!isPreviewPage)
		{
			setIconFileRequired(false);
			setBannerFileRequired(false);
			setIsPreviewPage(true);
			callback("Create New Message Board - Review");
		}
		else if (isPreviewPage) {
			handleMessageSave(event);
		}
	}

	const handleBackClick = (event) => {
		event.preventDefault();
		if (isPreviewPage) {
			setIsPreviewPage(false);
		}
		else if (!isPreviewPage) {
			history.goBack();
		}
	}

	const handleMessageEditSave = e => {
		handleMessageSave(e);
	}

	const handleMessageSave = async (event) => {
		event.preventDefault();

		if (content.trim() == "") {
			setIsDescEmpty(true);
		}
		else {
			if (!isIconEmpty && !isBannerEmpty) {
				setIsSaveInProgress(true);
				setShowModal(true);
				var inp = messageObject;
				setIsDescEmpty(false);
				inp.descriptionHtml = content;
				inp.isActive = isActive;
				inp.allowAttachments = allowAttachments;
				inp.isPrivate = isPrivate;
				inp.isPrayerHotlineChannel = isPrayerHotlineChannel;
				inp.isEmailSend = isEmailSend;
				setformSubmit(true);
				if (isEditIconChange) {
					inp.iconImageUrl = await uploadFileToBlob(inp.icon,
						Guid.newGuid() + messageObject.uniqueCode, "Image");
				}
				if (isEditBannerChange) {
					inp.bannerImageUrl = await uploadFileToBlob(inp.banner,
						Guid.newGuid() + messageObject.uniqueCode, "Image");
				}
				dispatch(messageBoardAction.messageBoardSave({ messageBoard: inp }));
				setIsErrorOnPage(false);
			}
		}
	};

	const handleInputChange = (event) => {
		let name = event.target.name;
		let value = event.target.value;

		if (name === "title") {
			var cusValue = value.toString().toLowerCase().replace(/[^a-z0-9]/gi, "-");
			setMessageObject({
				...messageObject,
				[name]: value,
				uniqueCode: cusValue,
			});
		}
		else {
			setMessageObject({
				...messageObject,
				[name]: value,
			});
		}
		setIsDirty(true)
	};

	const handleContentChange = (evt) => {
		var newContent = evt.getData();
		setContent(newContent);
		if (newContent.trim() !== "") {
			setIsDescEmpty(false);
		}
		setIsDirty(newContent.trim() !== "")
	}

	const handleImageClick = (type: string) => {
		if (type === "icon") {
			inputIconFile?.current?.click();
		} else if (type === "banner") {
			inputBannerFile?.current?.click();
		}
	};

	const handleFileChange = (event, key) => {
		const extension = event.target.files[0].name.split('.').pop()
		if (extension === "png" || extension === "jpg" || extension === "jpeg") {
			var file = event.target.files[0];
			if (key == "icon") {
				setSelectedIconFileName(file.name);
				setIsIconEmpty(false);
			}
			else if (key == "banner") {
				setSelectedBannerFileName(file.name);
				setIsBannerEmpty(false);
			}
			handleFileUpload(file, key);
			setIsDirty(true)
		} else {
			event.target.value = null;
			showAlert("Please select a valid image file", true);
		}
	};

	const handleFileUpload = (file, key) => {
		var reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onloadend = function (e) {
			if (key == "icon") {
				setIsEditIconChange(true);
				setMessageObject({
					...messageObject,
					icon: file,
					iconLocalPath: [reader.result]
				});
			}
			else if (key == "banner") {
				setIsEditBannerChange(true);
				setMessageObject({
					...messageObject,
					banner: file,
					bannerLocalPath: [reader.result]
				});
			}
		}.bind(this);
	};

	const handleModeratorsChange = (envet) => {
		setSelectedModertors(envet);
		const moderators = [] as any;
		envet && envet.map((data: any) =>
			moderators.push(data.value)
		)
		setMessageObject({
			...messageObject,
			moderatorsId: moderators
		});
		setIsDirty(true)
	}

	const handleDeleteMessageBoard = (e) => {
		e.preventDefault();
		setShowDeleteModal(true);
	}

	const handleDeleteModal = (value: boolean) => {
		if (value) {
			dispatch(messageBoardAction.messageBoardDelete(id))
			setShowModal(true);
		}
		setShowDeleteModal(false);
	};

	const handleEditPrayerHotlineChange = () => {
		if (isPrayerHotlineChannel && messageObject.isPrayerHotlineChannelEnabled) {
			setShowHotlineConfirmModal(true);
			return;
		}
		setIsPrayerHotlineChannel(!isPrayerHotlineChannel);
		setIsDirty(true);
	};

	const handleHotlineConfirmModal = (value: boolean) => {
		if (value) {
			setIsPrayerHotlineChannel(false);
			setMessageObject({
				...messageObject,
				isPrayerHotlineChannelEnabled: false
			});
			setIsDirty(true);
		}
		setShowHotlineConfirmModal(false);
	};

	React.useEffect(() => {
		const eventHandler = (event: BeforeUnloadEvent) => {
			var sessionExpiry = window.localStorage.getItem('SESSIONEXPIRY');
			const inSession = Date.now() < Number(sessionExpiry)
			if (!formSubmit && inSession) {
				event.preventDefault();
				event.returnValue = "";
			}
		};
		if (isDirty) { window.addEventListener("beforeunload", eventHandler) }
		return () => { window.removeEventListener("beforeunload", eventHandler) };
	}, [isDirty && !formSubmit])

	return (
		<div className="forum-detail">
			{showModal && (<LoadingSpinnerModal isShowModal={showModal} modalChange={handleLoadShowModal} />)}
			<div className='card-box'>
				{id <= 0 && !isDetailLoaded && !isPreviewPage && (
					<form name="createform" onSubmit={handleNextClick} className="create-form">
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="title" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblMsgActive">Active</label>
							<div className={["col-sm-5"].join(" ")} data-testid="MsgActive">
								<div data-testid="msgDetailAddActive" className="form-check form-switch">
									<Input className="form-check-switch " type="checkbox" id="isActive" name="isActive"
										checked={isActive} onChange={() => { setIsActive(!isActive); }} />
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="title" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblMsgTitle">Title</label>
							<div data-testid="msgDetailAddTitle" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="text" isRequired={true} id="title" isHover={false} onChange={(event) => { handleInputChange(event) }} value={messageObject.title} maxLength={100} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="uniqueCode" className={["col-sm-2 col-form-label"].join(" ")}data-testid="lblMagUniqueCode">Unique Code</label>
							<div data-testid="msgDetailAddUnique" className={["col-sm-5"].join(" ")}>
								<Input disabled className={["form-control"].join(" ")} id="uniqueCode" name="uniqueCode"
									value={messageObject.uniqueCode} onChange={(event) => { handleInputChange(event) }} isHover={false} maxLength={100}/>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="description" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblMsgDescription">Description</label>
							<div data-testid="msgDetailAddContent" className={["col-sm-5"].join(" ")}>
								<DABHtmlEditor content={content} onChange={handleContentChange} id="description" />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="language" className={["col-sm-2 col-form-label"].join(" ")}data-testid="lblMsgLanguage">Language</label>
							<div data-testid="msgDetailAddLanguage" className={["col-sm-5"].join(" ")}>
								<DABDropDown id="languageCode" value={messageObject.languageCode} isRequired={true} isHover={false}
									onChange={(event) => { handleInputChange(event); handleLanguageChange(event); }} options={langList} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="channel" className={["col-sm-2 col-form-label"].join(" ")}data-testid="lblMsgPrimaryChannel">Primary Channel</label>
							<div data-testid="msgDetailAddChannel" className={["col-sm-5"].join(" ")}>
								<DABDropDown id="primaryChannelId" value={messageObject.primaryChannelId} isHover={false}
									onChange={(event) => { handleInputChange(event); handleChannelChange(event); }} options={channelList} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="icon" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblMsgIconImage">Upload Icon Image</label>
							<div className={["col-sm-5"].join(" ")}>
								<FormGroup data-testid="msgDetailAddIcon">
									<Input type="file" name="iconFile" id="imgIcon" required={iconFileRequired}
										accept="image/png, image/jpeg, image/jpg"
										onChange={(e) => { handleFileChange(e, "icon") }} />
									<FormText color="muted">
										Selected File: {selectedIconFileName}<br />
										Icon size : 200 X 200, Max file size 5mb
									</FormText>
								</FormGroup>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="banner" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblMsgBannerImage">Upload Banner Image</label>
							<div className={["col-sm-5"].join(" ")}>
								<FormGroup data-testid="msgDetailAddBanner">
									<Input type="file" name="bannerFile" id="imgIcon" required={bannerFileRequired}
										accept="image/png, image/jpeg, image/jpg"
										onChange={(e) => {  handleFileChange(e, "banner") }} />
									<FormText color="muted">
										Selected File: {selectedBannerFileName}<br />
										Icon size : 200 X 200, Max file size 200mb
									</FormText>
								</FormGroup>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="moderators" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblModerators">Moderator(s)</label>
							<div data-testid="msgDetailAddModerator" className={["col-sm-5"].join(" ")}>
								<MultiSelect data-testid="msgDetailAddModeratorList"
									options={moderatorsList}
									value={selectedModerators}
									onChange={handleModeratorsChange}
									hasSelectAll={false}
									labelledBy="Start typing a username…"
								/>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="allowAttachments" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblAllowAttachMents">Allow Attachments</label>
							<div data-testid="msgDetailAllowAttachment" className={["col-sm-5"].join(" ")}>
								<input className="" type="checkbox" id="allowAttachments" name="allowAttachments"
									checked={allowAttachments} onChange={() => { setAllowAttachments(!allowAttachments); }}  />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="dailyMessageLimit" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblDailyMessageLink">Daily Message Limit</label>
							<div data-testid="msgDetailDailyMessageLimit" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="text" id="dailyMessageLimit" isHover={false} onChange={(event) => { handleInputChange(event) }} value={messageObject.dailyMessageLimit} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="dailyReplyLimit" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblDailyReplyLimit">Daily Reply Limit</label>
							<div data-testid="msgDetailDailyReplyLimit" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="text" id="dailyReplyLimit" isHover={false} onChange={(event) => { handleInputChange(event) }} value={messageObject.dailyReplyLimit} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isPrivate" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblPrivate">Private</label>
							<div data-testid="msgDetailPrivate" className={["col-sm-5"].join(" ")}>
								<input className="" type="checkbox" id="isPrivate" name="isPrivate"
									checked={isPrivate} onChange={() => { setIsPrivate(!isPrivate); setIsDirty(true) }} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isPrayerHotlineChannel" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblPrayerHotlineChannel">Prayer Hotline Channel</label>
							<div data-testid="msgDetailPrayerHotlineChannel" className={["col-sm-5"].join(" ")}>
								<input className="" type="checkbox" id="isPrayerHotlineChannel" name="isPrayerHotlineChannel"
									checked={isPrayerHotlineChannel} onChange={() => { setIsPrayerHotlineChannel(!isPrayerHotlineChannel); setIsDirty(true) }} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isEmailSend" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblEmailSend">Send Email</label>
							<div data-testid="msgDetailEmailSend" className={["col-sm-5"].join(" ")}>
								<input className="" type="checkbox" id="isEmailSend" name="isEmailSend"
									checked={isEmailSend} onChange={() => { setIsEmailSend(!isEmailSend); setIsDirty(true) }} />
							</div>
						</div>
						<Row className="fd-buttons">
							<Col lg="3" data-testid="msgDetailAddCancel">
								<Button className="" onClick={(e) => { handleBackClick(e); }}>CANCEL</Button>
							</Col>
							<Col lg="2" data-testid="msgDetailAddNext">
								<Button type="submit" className="btn-submit-frm" value="Next">NEXT</Button>
							</Col>
						</Row>
					</form>
				)}
				{id <= 0 && !isDetailLoaded && isPreviewPage && (
					<form name="createform" onSubmit={handleMessageSave} className="preview-form">
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="active" className={["col-sm-2 col-form-label"].join(" ")}>Active</label>
							<div className={["col-sm-5"].join(" ")}>
								<div data-testid="msgDetailPrevActive" className={["col-sm-5 col-form-label-value"].join(" ")}>
									{isActive ? "Yes" : "No"}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="title" className={["col-sm-2 col-form-label"].join(" ")}>Title</label>
							<div className={["col-sm-5"].join(" ")}>
								<div data-testid="msgDetailPrevTitle" className={["col-sm-5 col-form-label-value"].join(" ")}>
									{messageObject.title}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="uniqueCode" className={["col-sm-2 col-form-label"].join(" ")}>Unique Code</label>
							<div className={["col-sm-5"].join(" ")}>
								<div data-testid="msgDetailPrevUnique" className={["col-sm-5 col-form-label-value"].join(" ")}>
									{messageObject.uniqueCode}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="description" className={["col-sm-2 col-form-label"].join(" ")}>Description</label>
							<div data-testid="msgDetailPrevContent" className={["col-sm-5"].join(" ")}>
								<DABHtmlEditor content={content} onChange={handleContentChange} id="description" />
								<div style={{ display: `${isDescEmpty ? '' : 'none'}` }}><label data-testid="prevDescription" className="text-danger">Please type description</label></div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="language" className={["col-sm-2 col-form-label"].join(" ")}>Language</label>
							<div className={["col-sm-5"].join(" ")}>
								<div data-testid="msgDetailPrevLanguage" className={["col-sm-5 col-form-label-value"].join(" ")}>
									{languageName}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="primaryChannel" className={["col-sm-2 col-form-label"].join(" ")}>Primary Channel</label>
							<div className={["col-sm-5"].join(" ")}>
								<div data-testid="msgDetailPrevPrimaryChannel" className={["col-sm-5 col-form-label-value"].join(" ")}>
									{channelName}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="icon" className={["col-sm-2 col-form-label"].join(" ")}>Upload Icon Image</label>
							<div className={["col-sm-5"].join(" ")}>
								<div data-testid="msgDetailPrevIcon" className={["col-sm-5 col-form-label-value"].join(" ")}>
									<CardImg onError={(e: any) => { e.target.src = NoImage }}
										className='card-box-img-icon' top width="100%"
										src={messageObject.iconLocalPath}
										alt={messageObject.title} />
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="banner" className={["col-sm-2 col-form-label"].join(" ")}>Upload Banner Image</label>
							<div className={["col-sm-5"].join(" ")}>
								<div data-testid="msgDetailPrevBanner" className={["col-sm-5 col-form-label-value"].join(" ")}>
									<CardImg onError={(e: any) => { e.target.src = NoImage }}
										className='card-box-img-banner' top width="100%"
										src={messageObject.bannerLocalPath}
										alt={messageObject.title} />
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="moderator" className={["col-sm-2 col-form-label"].join(" ")}>Moderator(s)</label>
							<div data-testid="msgDetailPrevModerator" className={["col-sm-5 col-form-label-value"].join(" ")}>
								{selectedModerators && selectedModerators.map((data: any) =>
									data.label + ", "
								)}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="allowAttachments" className={["col-sm-2 col-form-label"].join(" ")}>Allow Attachments</label>
							<div className={["col-sm-5"].join(" ")}>
								<div data-testid="msgDetailPrevAllowAttachments" className={["col-sm-5 col-form-label-value"].join(" ")}>
									{allowAttachments? "Yes" : "No"}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="dailyMessageLimit" className={["col-sm-2 col-form-label"].join(" ")}>Daily Message Limit</label>
							<div className={["col-sm-5"].join(" ")}>
								<div data-testid="msgDetailPrevDailyMessageLimit" className={["col-sm-5 col-form-label-value"].join(" ")}>
									{messageObject.dailyMessageLimit}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="dailyReplyLimit" className={["col-sm-2 col-form-label"].join(" ")}>Daily Reply Limit</label>
							<div className={["col-sm-5"].join(" ")}>
								<div data-testid="msgDetailPrevDailyReplyLimit" className={["col-sm-5 col-form-label-value"].join(" ")}>
									{messageObject.dailyReplyLimit}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isPrivate" className={["col-sm-2 col-form-label"].join(" ")}>Private</label>
							<div className={["col-sm-5"].join(" ")}>
								<div data-testid="msgDetailPrevPrivate" className={["col-sm-5 col-form-label-value"].join(" ")}>
									{isPrivate ? "Yes" : "No"}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isPrayerHotlineChannel" className={["col-sm-2 col-form-label"].join(" ")}>Prayer Hotline Channel</label>
							<div className={["col-sm-5"].join(" ")}>
								<div data-testid="msgDetailPrevPrayerHotlineChannel" className={["col-sm-5 col-form-label-value"].join(" ")}>
									{isPrayerHotlineChannel ? "Yes" : "No"}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isEmailSend" className={["col-sm-2 col-form-label"].join(" ")}>Send Email</label>
							<div className={["col-sm-5"].join(" ")}>
								<div data-testid="msgDetailPrevEmailSend" className={["col-sm-5 col-form-label-value"].join(" ")}>
									{isEmailSend ? "Yes" : "No"}
								</div>
							</div>
						</div>
						<Row className="fd-buttons">
							<Col lg="3" data-testid="msgDetailPrevBack">
								<Button className=""
									onClick={(e) => { handleBackClick(e); }}>BACK</Button>
							</Col>
							<Col lg="2" data-testid="msgDetailPrevCreate">
								<Button className="btn-submit-frm"
									onClick={(e) => { handleNextClick(e); }}>CREATE</Button>
							</Col>
						</Row>
					</form>
				)}
				{id > 0 && isDetailLoaded && (
					<form name="createform" onSubmit={handleMessageEditSave} className="update-form">
						<DABBackToList onClick={(e) => { handleBackClick(e); }} />
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="active" className={["col-sm-2 col-form-label"].join(" ")}>Active</label>
							<div className={["col-sm-5"].join(" ")}>
								<div data-testid="msgDetailEditActive" className="form-check form-switch">
									<Input className="form-check-switch " type="checkbox" id="isActive"
										name="isActive" checked={isActive} onChange={(event) => { setIsActive(!isActive); }} />
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="title" className={["col-sm-2 col-form-label"].join(" ")}>Board Name</label>
							<div data-testid="msgDetailEditTitle" className={["col-sm-5"].join(" ")}>
								<DABTextBox isRequired={true} type="text" id="title" onChange={(event) => { handleInputChange(event) }}
									value={messageObject.title} isHover={true} maxLength={100}/>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="uniqueCode" className={["col-sm-2 col-form-label"].join(" ")}>Unique Code</label>
							<div data-testid="msgDetailEditUnique" className={["col-sm-5 text-field"].join(" ")}>
								<Input disabled className={["form-control"].join(" ")} id="uniqueCode" name="uniqueCode"
									value={messageObject.uniqueCode} onChange={(event) => { handleInputChange(event) }} maxLength={100}/>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label className={["col-sm-2 col-form-label"].join(" ")}>Description</label>
							<div data-testid="msgDetailEditContent" className={["col-sm-5"].join(" ")}>
								<DABHtmlEditor content={content} onChange={handleContentChange} id="description" />
								<div style={{ display: `${isDescEmpty ? '' : 'none'}` }}><label data-testid="errDescription" className="text-danger">Please type description</label></div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="language" className={["col-sm-2 col-form-label"].join(" ")}>Language</label>
							<div data-testid="msgDetailEditLangauge" className={["col-sm-5"].join(" ")}>
								<DABDropDown id="languageCode" value={messageObject.languageCode} isRequired={true}
									onChange={(event) => { handleInputChange(event); handleLanguageChange(event); }} options={langList} isHover={false} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="channel" className={["col-sm-2 col-form-label"].join(" ")}>Primary Channel</label>
							<div data-testid="msgDetailEditChannel" className={["col-sm-5"].join(" ")}>
								<DABDropDown id="primaryChannelId" value={messageObject.primaryChannelId} isHover={false}
									onChange={(event) => { handleInputChange(event); handleChannelChange(event); }} options={channelList} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="sortorder" className={["col-sm-2 col-form-label"].join(" ")}>Sort Order</label>
							<div data-testid="msgDetailEditSort" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="number" id="sortOrder" onChange={(event) => { handleInputChange(event) }} value={messageObject.sortOrder} isHover={false} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="icon" className={["col-sm-2 col-form-label"].join(" ")}>Upload Icon Image</label>
							<div data-testid="msgDetailEditIcon" className={["col-sm-5"].join(" ")}>
								<CardImg className='card-box-img-icon' top width="100%"
									src={isEditIconChange ? messageObject.iconLocalPath : messageObject.iconImageUrl}
									alt={messageObject.title} onClick={() => { handleImageClick("icon") }}
									onError={(e: any) => { e.target.src = NoImage }} />
								<input type="file" name="iconFile" id="imgIcon" ref={inputIconFile}
									accept="image/png, image/jpeg, image/jpg"
									onChange={(e) => { handleFileChange(e, "icon") }} style={{ display: 'none' }}
								/>
								<div style={{ display: `${isIconEmpty ? '' : 'none'}` }}><label data-testid="errIcon" className="text-danger">Please upload icon image</label></div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="banner" className={["col-sm-2 col-form-label"].join(" ")}>Upload Banner Image</label>
							<div data-testid="msgDetailEditBanner" className={["col-sm-5"].join(" ")}>
								<CardImg className='card-box-img-banner' top width="100%"
									src={isEditBannerChange ? messageObject.bannerLocalPath : messageObject.bannerImageUrl }
									alt={messageObject.title} onClick={() => { handleImageClick("banner") }}
									onError={(e: any) => { e.target.src = NoImage }} />
								<input type="file" name="bannerFile" id="imgBanner" ref={inputBannerFile}
									accept="image/png, image/jpeg, image/jpg"
									onChange={(e) => { handleFileChange(e, "banner") }} style={{ display: 'none' }} />
								<div style={{ display: `${isBannerEmpty ? '' : 'none'}` }}><label data-testid="errBanner" className="text-danger">Please upload banner image</label></div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="moderator" className={["col-sm-2 col-form-label"].join(" ")}>Moderators</label>
							<div data-testid="msgDetailEditModerator" className={["col-sm-5"].join(" ")}>
								<MultiSelect
									options={moderatorsList}
									value={selectedModerators}
									onChange={handleModeratorsChange}
									hasSelectAll={false}
									labelledBy="Start typing a username…"
								/>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="allowAttachments" className={["col-sm-2 col-form-label"].join(" ")}>Allow Attachments</label>
							<div data-testid="msgDetailEditAllowAttachments" className={["col-sm-5 col-flex"].join(" ")}>
								<input className="form-check-input" type="checkbox" id="allowAttachments" name="allowAttachments"
									defaultChecked={messageObject.allowAttachments} onChange={() => { setAllowAttachments(!allowAttachments); }} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="dailyMessageLimit" className={["col-sm-2 col-form-label"].join(" ")}>Daily Message Limit</label>
							<div data-testid="msgDetailEditDailyMessageLimit" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="text" id="dailyMessageLimit" isHover={false} onChange={(event) => { handleInputChange(event) }} value={messageObject.dailyMessageLimit} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="dailyReplyLimit" className={["col-sm-2 col-form-label"].join(" ")}>Daily Reply Limit</label>
							<div data-testid="msgDetailEditDailyReplyLimit" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="text" id="dailyReplyLimit" isHover={false} onChange={(event) => { handleInputChange(event) }} value={messageObject.dailyReplyLimit} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isPrivate" className={["col-sm-2 col-form-label"].join(" ")}>Private</label>
							<div data-testid="msgDetailEditPrivate" className={["col-sm-5 col-flex"].join(" ")}>
								<input className="form-check-input" type="checkbox" id="isPrivate" name="isPrivate"
									defaultChecked={messageObject.isPrivate} onChange={() => { setIsPrivate(!isPrivate); }} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isPrayerHotlineChannel" className={["col-sm-2 col-form-label"].join(" ")}>Prayer Hotline Channel</label>
							<div data-testid="msgDetailEditPrayerHotlineChannel" className={["col-sm-5 col-flex"].join(" ")}>
								<input className="form-check-input" type="checkbox" id="isPrayerHotlineChannel" name="isPrayerHotlineChannel"
									checked={isPrayerHotlineChannel} onChange={handleEditPrayerHotlineChange} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isEmailSend" className={["col-sm-2 col-form-label"].join(" ")}>Send Email</label>
							<div data-testid="msgDetailEditEmailSend" className={["col-sm-5 col-flex"].join(" ")}>
								<input className="form-check-input" type="checkbox" id="isEmailSend" name="isEmailSend"
									checked={isEmailSend} onChange={() => { setIsEmailSend(!isEmailSend); setIsDirty(true) }} />
							</div>
						</div>
						<Row className={`fd-buttons ${messageObject.topicCount < 1 ? "extend" : ""}`}>
							{messageObject.topicCount < 1 && <Col lg="2" data-testid="msgDetailDelete" className={["pull-right"].join(" ")}>
								<DABButton id="delete" className="" onClick={(e)=>handleDeleteMessageBoard(e)} value="DELETE"></DABButton>
							</Col>}
							<Col lg="3" data-testid="msgDetailEditSave" className={["pull-right"].join(" ")}>
								<DABButton id="Submit" className="btn-submit-frm" value="SAVE CHANGES"></DABButton>
							</Col>
						</Row>
					</form>
				)}
				<ConfirmModal isShowModal={showDeleteModal} deleteMessage={"Are you sure, Do you want to remove this message board? "} modalChange={handleDeleteModal} />
				{showHotlineConfirmModal && (
					<ConfirmModal isShowModal={showHotlineConfirmModal} modalTitle="Prayer Hotline Channel" cancelText="Cancel"
						deleteMessage={"This Message Board is currently enabled in the Prayer Hotline Channel settings. Disabling this option will remove the Message Board from the Prayer Hotline Channel list. Do you want to continue?"}
						modalChange={handleHotlineConfirmModal} />
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { messageBoardData, languageData, userData, channelData } = state;
	return {
		messageBoardData, languageData, userData, channelData
	};
};

export default connect(mapStateToProps)(MessageBoardDetails);